import { render, staticRenderFns } from "./EditFaturaPage.vue?vue&type=template&id=58692ae1&"
import script from "./EditFaturaPage.vue?vue&type=script&lang=js&"
export * from "./EditFaturaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports